// extracted by mini-css-extract-plugin
module.exports = {"share-url__default":"share-url_share-url__default__EUgih"};